import { create } from "zustand";

const useAuthStore = create((set) => ({
    authSession: null,
    authStatus: null,
    setAuthSession: ({ session, status }) =>
        set({ authSession: session, authStatus: status }),
}));

export default useAuthStore;
